// removed by extract-text-webpack-plugin
module.exports = {"root":"_3JAPj","description":"_10X_S","button":"_3AItI","help":"_30Gp4","changeEmail":"_2NOQ-","image":"_27xK4"};


//////////////////
// WEBPACK FOOTER
// ./app/components/EmailVerificationInfo/EmailVerificationInfo.scss
// module id = 1277
// module chunks = 1